import { onBeforeUnmount, onMounted, ref, type WatchOptions, type WatchSource } from 'vue';

export function useMountedWatch<T extends WatchSource>(
  deps: T | T[],
  callback: (newValue?: T[], oldValue?: T[], OnCleanup?: (cleanupFn: () => void) => void) => void,
  options?: WatchOptions,
) {
  const init = ref(false);

  onMounted(() => {
    init.value = true;
  });

  const _deps = Array.isArray(deps) ? [() => init.value, ...deps] : [() => init.value, deps];

  // 保存 watch 的停止函数，在组件卸载时调用
  const stopWatch = watch(
    _deps,
    (newValue, oldValue, onCleanup) => {
      // 确保在组件挂载后执行
      const [_newInit, ...newVal] = newValue as T[];
      const [_oldInit, ...oldVal] = oldValue as T[];
      if (_newInit) {
        callback(newVal, oldVal, onCleanup);
      }
    },
    options,
  );

  // 组件卸载时停止 watch
  onBeforeUnmount(() => {
    stopWatch();
  });
}
